import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProvinceService {
  private province$ = new BehaviorSubject<number>(0);
  public selectedProvince$ = this.province$.asObservable();

  setProvince(id: number): void {
    this.province$.next(id);
  }

  get currentProvince(): number {
    return this.province$.getValue();
  }
}
